import Cancellation from '../Cancellation';
import RefundHelp from '../RefundHelp';
import ReturnFAQs from '../ReturnFAQs';
import { Doubts, RefundContainer, RefundContent, Title } from './styled';

export default function index() {
  return (
    <div>
      <RefundContainer margin="0 auto">
        <Title>Return &amp; Refund</Title>
        <RefundContent myloRefund>
          Mylo allows easy return, replacement &amp; refund of eligible
          products. Return window is 15 days so once the order is delivered, you
          can return within 15 days of receiving the orders.
        </RefundContent>
        <Doubts whatProducts>What products are not-returnable?</Doubts>
        <RefundContent>
          Please refer to individual products listing pages to know if the
          products are eligible for return.
        </RefundContent>
        <Doubts whatProducts>How to place return requests:</Doubts>
        <RefundContent>
          You can initiate return requests either through the My Orders page or
          through customer chat support.
        </RefundContent>
        <RefundContent>
          After reviewing your return request, we will send our courier partner
          to pick up the products delivered to you. This will take 3-4 business
          days.
        </RefundContent>
        <RefundContent>
          After the returned products are received by us, we will verify them
          against the claim and initiate replacement or refund accordingly.
        </RefundContent>
        <RefundContent>
          After the return request is approved, it may take up to 10-14 business
          days for the credit to reflect in Your account. The actual time taken
          for refund or credit of the payment into your account depends on the
          mode by which the payment was made, and the procedures adopted by
          various financial services providers.
        </RefundContent>
      </RefundContainer>
      <Cancellation />
      <ReturnFAQs />
      <RefundHelp />
    </div>
  );
}
